<template>
	<div class="wrapper">
		<headerTag />
		<div class="Agreement-wrap">
			<h1>零分享-服务协议</h1>
			<div class="Agreement-info">
				<h5>1.甲方（委托方）的权利义务</h5>
				<p>
					<em>1.1</em>
					<span>甲方应指定专人配合乙方完成企业登记或代理记账等事务，并提供齐全的证件和规范的法律文件资料。</span>
				</p>
				<p>
					<em>1.2</em>
					<span>甲方对提供的证件和法律文件资料的真实性.正确性.合法性承担全部责任。</span>
				</p>
				<p>
					<em>1.3</em>
					<span>甲方应承担向工商.税务.技监等机关缴纳的有关费用。如乙方代为缴纳，甲方应在费用发生前或发生时支付给乙方。</span>
				</p>
				<p>
					<em>1.4</em>
					<span>甲方委托乙方办理变更公司法人股东，其中对公账户只含有基本户开户许可证的法人变更，如甲方须办理其他的对公账户或一般户的变更/注销，由甲乙双方另行协商代办费用（因一般户可能开在异地）。</span>
				</p>
				<p>
					<em>1.5</em>
					<span>甲方在服务期届满时应及时续费，否则，所产生的不利后果（包括但不限于公司税务异常.地址异常.账务异常等）由甲方自行承担。</span>
				</p>
			</div>
			<div class="Agreement-info">
				<h5>2.乙方(受托方)的权利义务</h5>
				<p>
					<em>2.1</em>
					<span>乙方应遵守国家有关法律.法规.依法从事企业登记和记账代理工作。</span>
				</p>
				<p>
					<em>2.2</em>
					<span>乙方自觉接受工商行政管理机关和税务机关的指导和监督，采用规范的登记代理程序和方法，协助委托方完善各类文件资料，齐全应有的证件。</span>
				</p>
				<p>
					<em>2.3</em>
					<span>乙方对甲方提供的证件和资料负有妥善保管和保密责任，乙方不得将证件和资料提供给与企业登记和代理记账（包括工商.技监.税务等部门）无关的其他第三者。</span>
				</p>
				<p>
					<em>2.4</em>
					<span>乙方根据甲方提供的信息撰写材料，甲方确认无误后签名盖章，意味着甲方认可乙方撰写的材料符合甲方的真实情况，并对申请材料的真实性负全部责任，如果因为材料不真实造成一切后果，均由甲方承担，与乙方无关。</span>
				</p>
				<p>
					<em>2.5</em>
					<span>非乙方原因造成本协议无法履行的，乙方有权不退还服务费。</span>
				</p>
			</div>
			<div class="Agreement-info">
				<h5>3.保密条款</h5>
				<p>
					<em>3.1</em>
					<span>协议各方均有义务对本协议所有内容进行保密，保密期限不限于本协议有效期限，也不因本协议解除.终止.无效或被撤销而失效，即你应对零分享提供服务之全过程情况承担保密义务，而零分享应对在与你合作中了解到的你的相关信息承担保密义务。</span>
				</p>
			</div>
			<div class="Agreement-info">
				<h5>4.争议解决</h5>
				<p>
					<em>4.1</em>
					<span>如因本协议发生争议，双方应本着有利于案件进展，维护你权益的原则友好协商解决，如协商不能达成一致，双方提交上海仲裁委员会仲裁。</span>
				</p>
			</div>
			<div class="Agreement-info">
				<h5>5.其他</h5>
				<p>
					<em>5.1</em>
					<span>当你仔细阅读本协议并在零分享网站上支付服务费成功后，即表示你与零分享之间就本协议内容已达成完全一致，已确认由零分享开始为您提供服务，本协议即时生效。</span>
				</p>
				<p>
					<em>5.2</em>
					<span>本协议于本协议项下全部服务事宜完成之日终止。若一方因特殊原因需要提前终止合同，需提前一个月通知对方并且协商，双方协商达成一致前提下方可提前终止。</span>
				</p>
			</div>
		</div>
	</div>

</template>

<script>
   
    import "../../assets/css/user.scss"
    import headerTag from '@/components/headerTag/headerTag.vue'
    
    export default {
    	name: 'agreement',
    	props: {
        
    	},
    	components: {
    		headerTag,
    	},
    }
</script>


